  (function () {
    var carouselRegistry = window.__MiniGearCarouselRegistry = window.__MiniGearCarouselRegistry || {};

    function initMiniGearProductCarousel(sectionId) {
      var section = document.getElementById(sectionId);
      if (!section) return;

      var existing = carouselRegistry[sectionId];
      if (existing && existing.element === section && section.dataset.mgCarouselReady === 'true') return;
      if (existing && typeof existing.cleanup === 'function') {
        existing.cleanup();
      }

      var viewport = section.querySelector('[data-mg-product-viewport]');
      var track = section.querySelector('[data-mg-product-track]');
      var prevButton = section.querySelector('[data-mg-product-prev]');
      var nextButton = section.querySelector('[data-mg-product-next]');

      var quickview = section.querySelector('[data-mg-product-quickview]');
      var qvStage = section.querySelector('[data-mg-qv-stage]');
      var qvThumbs = section.querySelector('[data-mg-qv-thumbs]');
      var qvLink = section.querySelector('[data-mg-qv-link]');
      var qvClose = section.querySelector('[data-mg-qv-close]');
      var qvPrev = section.querySelector('[data-mg-qv-prev]');
      var qvNext = section.querySelector('[data-mg-qv-next]');
      var qvDialog = quickview ? quickview.querySelector('.mg-product-quickview__dialog') : null;

      if (!viewport || !track) return;

      section.dataset.mgCarouselReady = 'true';

      var globalBound = [];

      function onGlobal(target, eventName, handler, options) {
        target.addEventListener(eventName, handler, options);
        globalBound.push([target, eventName, handler, options]);
      }

      function cleanupCarousel() {
        globalBound.forEach(function (entry) {
          entry[0].removeEventListener(entry[1], entry[2], entry[3]);
        });
        globalBound = [];

        window.cancelAnimationFrame(resizeFrame);
        clearTransitionWaiter();

        if (cardVisibilityObserver) cardVisibilityObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        window.clearTimeout(qvTransitionTimer);
        window.clearTimeout(qvCloseTimer);
        window.clearTimeout(qvHistoryFallbackTimer);

        var ownsOpenQuickview = quickview && !quickview.hidden;

        if (ownsOpenQuickview) {
          document.body.classList.remove('mg-product-quickview-lock');
          quickview.classList.remove('is-open');
          quickview.hidden = true;

          if (typeof removeTrapFocus === 'function') {
            removeTrapFocus();
          }
        }

        section.dataset.mgCarouselReady = 'false';

        if (carouselRegistry[sectionId] && carouselRegistry[sectionId].element === section) {
          delete carouselRegistry[sectionId];
        }
      }

      carouselRegistry[sectionId] = {
        element: section,
        cleanup: cleanupCarousel
      };

      var resizeFrame = null;
      var transitionTimer = null;
      var transitionHandler = null;
      var cardVisibilityObserver = null;
      var resizeObserver = null;
      var geometry = { step: 0, cardWidth: 0, gap: 0 };
      var mobileSnapMedia = window.matchMedia
        ? window.matchMedia('(max-width: 749px), (orientation: landscape) and (max-width: 989px) and (max-height: 520px)')
        : null;
      var desktopMedia = window.matchMedia
        ? window.matchMedia('(min-width: 990px) and (min-height: 521px)')
        : null;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.mg-product-card'));
      var transitionDuration = 320;
      var isAnimating = false;
      var pointerId = null;
      var pointerStartX = 0;
      var pointerStartY = 0;
      var pointerDx = 0;
      var dragPrepared = false;
      var mobileBufferActive = false;
      var dragAxis = null;
      var moved = false;

      function isMobileSnapMode() {
        return mobileSnapMedia ? mobileSnapMedia.matches : false;
      }

      function isDesktop() {
        return desktopMedia ? desktopMedia.matches : false;
      }

      function refreshCards() {
        cards = Array.prototype.slice.call(track.querySelectorAll('.mg-product-card'));
        return cards;
      }

      function invalidateGeometry() {
        geometry.step = 0;
        geometry.cardWidth = 0;
        geometry.gap = 0;
      }

      function measureGeometry() {
        var firstCard = track.querySelector('.mg-product-card');
        if (!firstCard) {
          geometry.step = 320;
          geometry.cardWidth = 320;
          geometry.gap = 0;
          return geometry;
        }

        var cardWidth = firstCard.getBoundingClientRect().width;
        var trackStyles = window.getComputedStyle(track);
        var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0) || 0;

        geometry.cardWidth = cardWidth;
        geometry.gap = gap;
        geometry.step = cardWidth + gap;
        return geometry;
      }

      function getStep() {
        if (!geometry.step) measureGeometry();
        return geometry.step || 320;
      }

      function setTrackX(value, animate) {
        track.style.transition = animate
          ? 'transform ' + transitionDuration + 'ms cubic-bezier(0.22, 0.61, 0.36, 1)'
          : 'none';
        track.style.transform = 'translate3d(' + value + 'px, 0, 0)';
      }

      function clearTransitionWaiter() {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
        if (transitionHandler) {
          track.removeEventListener('transitionend', transitionHandler);
          transitionHandler = null;
        }
      }

      function animateTrackTo(value, callback) {
        if (isAnimating) return false;
        isAnimating = true;
        clearTransitionWaiter();

        var finished = false;
        function finish(event) {
          if (finished) return;
          if (event && event.target !== track) return;
          finished = true;
          clearTransitionWaiter();
          isAnimating = false;
          if (typeof callback === 'function') callback();
        }

        transitionHandler = finish;
        track.addEventListener('transitionend', transitionHandler);
        transitionTimer = window.setTimeout(function () { finish(); }, transitionDuration + 90);

        window.requestAnimationFrame(function () {
          setTrackX(value, true);
        });
        return true;
      }

      function activateMobileBuffer() {
        if (mobileBufferActive || cards.length < 2) return;

        var last = track.lastElementChild;
        var first = track.firstElementChild;
        if (!last || !first || last === first) return;

        track.insertBefore(last, first);
        refreshCards();
        mobileBufferActive = true;
        setTrackX(-getStep(), false);
      }

      function deactivateMobileBuffer() {
        if (!mobileBufferActive) return;

        var bufferedPrevious = track.firstElementChild;
        if (bufferedPrevious) track.appendChild(bufferedPrevious);
        refreshCards();
        mobileBufferActive = false;
        setTrackX(0, false);
      }

      function syncLoopMode() {
        if (isMobileSnapMode()) {
          activateMobileBuffer();
        } else {
          deactivateMobileBuffer();
          setTrackX(0, false);
        }
      }

      function moveNext() {
        if (isAnimating || dragPrepared || cards.length < 2) return;
        var step = getStep();

        if (isMobileSnapMode()) {
          activateMobileBuffer();
          animateTrackTo(-2 * step, function () {
            var previous = track.firstElementChild;
            if (previous) track.appendChild(previous);
            refreshCards();
            setTrackX(-step, false);
          });
          return;
        }

        animateTrackTo(-step, function () {
          var first = track.firstElementChild;
          if (first) track.appendChild(first);
          refreshCards();
          setTrackX(0, false);
        });
      }

      function movePrev() {
        if (isAnimating || dragPrepared || cards.length < 2) return;
        var step = getStep();

        if (isMobileSnapMode()) {
          activateMobileBuffer();
          animateTrackTo(0, function () {
            var previousPrevious = track.lastElementChild;
            var first = track.firstElementChild;
            if (previousPrevious && first && previousPrevious !== first) {
              track.insertBefore(previousPrevious, first);
            }
            refreshCards();
            setTrackX(-step, false);
          });
          return;
        }

        var last = track.lastElementChild;
        var first = track.firstElementChild;
        if (!last || !first || last === first) return;

        track.insertBefore(last, first);
        refreshCards();
        setTrackX(-step, false);
        void track.offsetWidth;
        animateTrackTo(0, function () {
          setTrackX(0, false);
        });
      }

      function prepareDragBuffer() {
        if (dragPrepared || isAnimating || cards.length < 2) return false;

        if (isMobileSnapMode()) {
          activateMobileBuffer();
          dragPrepared = true;
          return true;
        }

        var last = track.lastElementChild;
        var first = track.firstElementChild;
        if (!last || !first || last === first) return false;

        track.insertBefore(last, first);
        refreshCards();
        setTrackX(-getStep(), false);
        dragPrepared = true;
        return true;
      }

      function restorePreparedDragInstant() {
        if (!dragPrepared) return;

        if (isMobileSnapMode() && mobileBufferActive) {
          dragPrepared = false;
          setTrackX(-getStep(), false);
          return;
        }

        var prepared = track.firstElementChild;
        if (prepared) track.appendChild(prepared);
        refreshCards();
        dragPrepared = false;
        setTrackX(0, false);
      }

      function finishDrag(direction) {
        if (!dragPrepared) return;
        var step = getStep();

        if (isMobileSnapMode() && mobileBufferActive) {
          if (direction > 0) {
            animateTrackTo(0, function () {
              var previousPrevious = track.lastElementChild;
              var first = track.firstElementChild;
              if (previousPrevious && first && previousPrevious !== first) {
                track.insertBefore(previousPrevious, first);
              }
              refreshCards();
              dragPrepared = false;
              setTrackX(-step, false);
            });
            return;
          }

          if (direction < 0) {
            animateTrackTo(-2 * step, function () {
              var previous = track.firstElementChild;
              if (previous) track.appendChild(previous);
              refreshCards();
              dragPrepared = false;
              setTrackX(-step, false);
            });
            return;
          }

          animateTrackTo(-step, function () {
            dragPrepared = false;
            setTrackX(-step, false);
          });
          return;
        }

        if (direction > 0) {
          animateTrackTo(0, function () {
            dragPrepared = false;
            setTrackX(0, false);
          });
          return;
        }

        if (direction < 0) {
          animateTrackTo(-2 * step, function () {
            var first = track.firstElementChild;
            if (first) track.appendChild(first);
            first = track.firstElementChild;
            if (first) track.appendChild(first);
            refreshCards();
            dragPrepared = false;
            setTrackX(0, false);
          });
          return;
        }

        animateTrackTo(-step, function () {
          var prepared = track.firstElementChild;
          if (prepared) track.appendChild(prepared);
          refreshCards();
          dragPrepared = false;
          setTrackX(0, false);
        });
      }

      function setCardInteractive(card, interactive) {
        if (!card) return;
        var controls = card.querySelectorAll('button, a[href]');

        if (interactive) {
          card.removeAttribute('aria-hidden');
          Array.prototype.forEach.call(controls, function (control) {
            if (control.dataset.mgCarouselTabindex === 'managed') {
              control.removeAttribute('tabindex');
              delete control.dataset.mgCarouselTabindex;
            }
          });
        } else {
          card.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(controls, function (control) {
            if (!control.hasAttribute('tabindex')) {
              control.dataset.mgCarouselTabindex = 'managed';
            }
            control.setAttribute('tabindex', '-1');
          });
        }
      }

      function setupCardVisibilityObserver() {
        if (!('IntersectionObserver' in window)) {
          refreshCards().forEach(function (card) { setCardInteractive(card, true); });
          return;
        }

        cardVisibilityObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            setCardInteractive(entry.target, entry.isIntersecting && entry.intersectionRatio > 0.08);
          });
        }, {
          root: viewport,
          threshold: [0, 0.08, 0.5]
        });

        refreshCards().forEach(function (card) {
          cardVisibilityObserver.observe(card);
        });
      }

      function resizeShopifyImageUrl(src, width) {
        if (!src) return '';

        if (/([?&])width=\d+/.test(src)) {
          return src.replace(/([?&])width=\d+/, '$1width=' + width);
        }

        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      function bindImageFallback(img) {
        if (!img || img.dataset.mgRetryBound) return;
        img.dataset.mgRetryBound = 'true';
        img.addEventListener('error', function () {
          if (img.dataset.mgRetried === 'true') return;
          img.dataset.mgRetried = 'true';
          img.removeAttribute('srcset');
          img.src = resizeShopifyImageUrl(img.currentSrc || img.src, 720);
        });
      }

      function setupImageFallbacks() {
        // Native loading/fetchpriority handles scheduling more intelligently than
        // a fixed IntersectionObserver threshold, especially on constrained networks.
        // Keep only the CDN retry fallback here; do not override Liquid hints.
        Array.prototype.slice.call(track.querySelectorAll('[data-mg-card-image]')).forEach(bindImageFallback);
      }

      function handleResize() {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(function () {
          if (dragPrepared) restorePreparedDragInstant();
          clearTransitionWaiter();
          isAnimating = false;
          invalidateGeometry();
          measureGeometry();
          syncLoopMode();
        });
      }

      if (prevButton) prevButton.addEventListener('click', movePrev);
      if (nextButton) nextButton.addEventListener('click', moveNext);

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (isAnimating) return;
        if (!prepareDragBuffer()) return;

        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerDx = 0;
        dragAxis = null;
        moved = false;
      });

      viewport.addEventListener('pointermove', function (event) {
        if (pointerId === null || event.pointerId !== pointerId || !dragPrepared) return;

        var dx = event.clientX - pointerStartX;
        var dy = event.clientY - pointerStartY;

        if (!dragAxis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          dragAxis = Math.abs(dx) > Math.abs(dy) * 1.08 ? 'x' : 'y';
        }

        if (dragAxis !== 'x') return;

        if (event.cancelable) event.preventDefault();
        moved = Math.abs(dx) > 5;
        pointerDx = dx;
        viewport.classList.add('is-dragging');

        var step = getStep();
        var limitedDx = Math.max(-step * 1.15, Math.min(step * 1.15, dx));
        setTrackX(-step + limitedDx, false);
      }, { passive: false });

      function endPointerGesture(event, cancelled) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;

        var wasHorizontal = dragAxis === 'x';
        var dx = pointerDx;
        pointerId = null;
        pointerDx = 0;
        dragAxis = null;
        viewport.classList.remove('is-dragging');

        if (!dragPrepared) return;

        if (cancelled || !wasHorizontal) {
          restorePreparedDragInstant();
        } else {
          var threshold = Math.min(90, Math.max(44, getStep() * 0.16));
          if (dx >= threshold) {
            finishDrag(1);
          } else if (dx <= -threshold) {
            finishDrag(-1);
          } else {
            finishDrag(0);
          }
        }

        window.setTimeout(function () { moved = false; }, 0);
      }

      viewport.addEventListener('pointerup', function (event) {
        endPointerGesture(event, false);
      });
      viewport.addEventListener('pointercancel', function (event) {
        endPointerGesture(event, true);
      });
      viewport.addEventListener('lostpointercapture', function (event) {
        if (pointerId !== null && event.pointerId === pointerId) endPointerGesture(event, true);
      });

      viewport.addEventListener('click', function (event) {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(viewport);
      } else {
        onGlobal(window, 'resize', handleResize, { passive: true });
      }

      onGlobal(window, 'orientationchange', function () {
        window.setTimeout(handleResize, 220);
      }, { passive: true });

      measureGeometry();
      syncLoopMode();
      setupImageFallbacks();
      setupCardVisibilityObserver();

      if (!quickview || !qvStage || !qvThumbs || !qvLink || !qvClose) return;

      var galleryImages = [];
      var galleryIndex = 0;
      var qvTouchStartX = 0;
      var qvTouchStartY = 0;
      var qvHistoryPushed = false;
      var qvClosingFromHistory = false;
      var qvTransitionTimer = null;
      var qvCloseTimer = null;
      var qvHistoryFallbackTimer = null;
      var qvFocusTrigger = null;
      var imageViewLabelTemplate = section.getAttribute('data-mg-image-view-label-template') || '';
      var qvTransitionDuration = 260;
      var qvPreloadedImages = {};
      var qvImageWidths = [480, 720, 960, 1200, 1600, 2200];
      var qvImageSizes = '(max-width: 749px) calc(100vw - 28px), (orientation: landscape) and (max-width: 989px) and (max-height: 520px) calc(100vw - 28px), (max-width: 1392px) calc(100vw - 140px), 1252px';

      function getQvSrcset(image) {
        if (!image || !image.large) return '';
        if (image.srcset) return image.srcset;

        return qvImageWidths.map(function (width) {
          return resizeShopifyImageUrl(image.large, width) + ' ' + width + 'w';
        }).join(', ');
      }

      function preloadQvImage(image) {
        if (!image || !image.large || qvPreloadedImages[image.large]) return;

        var img = new Image();
        var srcset = getQvSrcset(image);

        if (srcset) {
          img.srcset = srcset;
          img.sizes = qvImageSizes;
        }

        if ('fetchPriority' in img) {
          img.fetchPriority = 'low';
        }

        img.decoding = 'async';
        img.src = image.large;

        qvPreloadedImages[image.large] = img;
      }

      function preloadNearbyQvImages(index) {
        if (!galleryImages.length) return;

        var nextIndex = index + 1;
        if (nextIndex >= galleryImages.length) nextIndex = 0;

        preloadQvImage(galleryImages[nextIndex]);

        if (galleryImages.length > 2) {
          var prevIndex = index - 1;
          if (prevIndex < 0) prevIndex = galleryImages.length - 1;
          preloadQvImage(galleryImages[prevIndex]);
        }
      }

      function clearOldQvImages() {
        var images = Array.prototype.slice.call(qvStage.querySelectorAll('.mg-product-quickview__image'));

        if (images.length <= 1) return;

        images.forEach(function (img) {
          if (!img.classList.contains('is-active')) {
            img.remove();
          }
        });
      }

      function createQvImage(image) {
        var img = document.createElement('img');
        var srcset = getQvSrcset(image);

        img.className = 'mg-product-quickview__image';
        img.alt = image.alt || '';
        img.decoding = 'async';
        img.style.objectPosition = image.position || '50% 50%';

        if (srcset) {
          img.srcset = srcset;
          img.sizes = qvImageSizes;
        }

        if ('fetchPriority' in img) {
          img.fetchPriority = 'high';
        }

        img.src = image.large || '';

        return img;
      }

      function fadeToQvImage(image, onReady) {
        if (!image || !image.large) return;

        var currentImage = qvStage.querySelector('.mg-product-quickview__image.is-active');

        if (currentImage && currentImage.getAttribute('src') === image.large) {
          return;
        }

        window.clearTimeout(qvTransitionTimer);

        var nextImage = createQvImage(image);

        function startFade() {
          clearOldQvImages();

          if (currentImage) {
            currentImage.classList.remove('is-active');
            currentImage.classList.add('is-leaving');
          }

          qvStage.appendChild(nextImage);

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              nextImage.classList.add('is-active');
            });
          });

          if (typeof onReady === 'function') {
            onReady();
          }

          qvTransitionTimer = window.setTimeout(function () {
            if (currentImage && currentImage.parentNode) {
              currentImage.remove();
            }

            clearOldQvImages();
          }, qvTransitionDuration + 120);
        }

        function waitForDecodeThenFade() {
          if (nextImage.decode) {
            nextImage.decode()
              .then(startFade)
              .catch(startFade);
          } else {
            startFade();
          }
        }

        if (nextImage.complete && nextImage.naturalWidth > 0) {
          waitForDecodeThenFade();
        } else {
          nextImage.onload = waitForDecodeThenFade;
          nextImage.onerror = startFade;
        }
      }

      function parseGallery(button) {
        var card = button.closest('[data-mg-product-card]');
        var productKey = card ? card.getAttribute('data-mg-product-key') : '';
        var script = productKey
          ? section.querySelector('[data-mg-product-gallery="' + productKey + '"]')
          : null;

        if (!script) return null;

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          return null;
        }
      }

      function setGalleryIndex(index) {
        if (!galleryImages.length) return;

        if (index < 0) index = galleryImages.length - 1;
        if (index >= galleryImages.length) index = 0;

        galleryIndex = index;

        var image = galleryImages[galleryIndex];

        var readyIndex = galleryIndex;

        fadeToQvImage(image, function () {
          preloadNearbyQvImages(readyIndex);
        });

        Array.prototype.slice.call(qvThumbs.querySelectorAll('.mg-product-quickview__thumb')).forEach(function (thumb, thumbIndex) {
          thumb.classList.toggle('is-active', thumbIndex === galleryIndex);
        });
      }

      function buildThumbs() {
        qvThumbs.innerHTML = '';

        galleryImages.forEach(function (image, index) {
          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'mg-product-quickview__thumb';
          var thumbLabel = imageViewLabelTemplate
            ? imageViewLabelTemplate.replace('__INDEX__', String(index + 1))
            : (image.alt || String(index + 1));
          thumb.setAttribute('aria-label', thumbLabel);

          var img = document.createElement('img');
          img.src = resizeShopifyImageUrl(image.large || '', 220);
          img.alt = image.alt || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.style.objectPosition = image.position || '50% 50%';

          thumb.appendChild(img);

          thumb.addEventListener('click', function () {
            setGalleryIndex(index);
          });

          qvThumbs.appendChild(thumb);
        });
      }

      function openQuickview(button) {
        if (moved) return;

        var data = parseGallery(button);

        if (!data || !data.images || !data.images.length) return;

        galleryImages = data.images;
        galleryIndex = 0;
        qvFocusTrigger = button;
        qvLink.href = data.url || '#';
        qvPreloadedImages = {};
        qvStage.innerHTML = '';

        buildThumbs();

        quickview.hidden = false;
        document.body.classList.add('mg-product-quickview-lock');

        setGalleryIndex(0);

        if (!qvHistoryPushed && window.history && window.history.pushState) {
          try {
            window.history.pushState({ mgProductQuickview: true }, '', window.location.href);
          qvHistoryPushed = true;
          } catch (error) {
            qvHistoryPushed = false;
          }
        }

        window.requestAnimationFrame(function () {
          quickview.classList.add('is-open');

          if (typeof trapFocus === 'function' && qvDialog) {
            trapFocus(qvDialog, qvClose);
          } else if (qvClose && typeof qvClose.focus === 'function') {
            qvClose.focus({ preventScroll: true });
          }
        });
      }

      function hardCloseQuickview() {
        quickview.classList.remove('is-open');
        document.body.classList.remove('mg-product-quickview-lock');

        window.clearTimeout(qvCloseTimer);
        qvCloseTimer = window.setTimeout(function () {
          qvCloseTimer = null;

          if (!quickview.classList.contains('is-open')) {
            quickview.hidden = true;
            qvStage.innerHTML = '';
            qvThumbs.innerHTML = '';
            galleryImages = [];
            galleryIndex = 0;
            qvPreloadedImages = {};
            qvClosingFromHistory = false;

            if (typeof removeTrapFocus === 'function') {
              removeTrapFocus();
            }

            if (qvFocusTrigger && qvFocusTrigger.isConnected && typeof qvFocusTrigger.focus === 'function') {
              qvFocusTrigger.focus({ preventScroll: true });
            }

            qvFocusTrigger = null;
          }
        }, 190);
      }

      function closeQuickview(fromHistory) {
        if (quickview.hidden) return;

        if (!fromHistory && qvHistoryPushed && window.history && window.history.back) {
          qvClosingFromHistory = true;
          window.history.back();

          window.clearTimeout(qvHistoryFallbackTimer);
          qvHistoryFallbackTimer = window.setTimeout(function () {
            qvHistoryFallbackTimer = null;

            if (qvClosingFromHistory && !quickview.hidden) {
              qvHistoryPushed = false;
              hardCloseQuickview();
            }
          }, 260);

          return;
        }

        qvHistoryPushed = false;
        qvClosingFromHistory = false;
        hardCloseQuickview();
      }

      function handleStageSwipe(endX, endY) {
        var diffX = qvTouchStartX - endX;
        var diffY = qvTouchStartY - endY;
        var absX = Math.abs(diffX);
        var absY = Math.abs(diffY);

        if (absY > 70 && absY > absX * 1.1) {
          closeQuickview(false);
          return;
        }

        if (absX > 44 && absX > absY * 1.1) {
          if (diffX > 0) {
            setGalleryIndex(galleryIndex + 1);
          } else {
            setGalleryIndex(galleryIndex - 1);
          }
        }
      }

      Array.prototype.slice.call(section.querySelectorAll('[data-mg-product-gallery-open]')).forEach(function (button) {
        button.addEventListener('click', function () {
          openQuickview(button);
        });
      });

      qvClose.addEventListener('click', function () {
        closeQuickview(false);
      });

      quickview.addEventListener('click', function (event) {
        if (event.target === quickview) {
          closeQuickview(false);
        }
      });

      quickview.addEventListener(
        'touchmove',
        function (event) {
          if (!quickview.hidden && event.cancelable && !qvThumbs.contains(event.target)) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      if (qvPrev) {
        qvPrev.addEventListener('click', function () {
          setGalleryIndex(galleryIndex - 1);
        });
      }

      if (qvNext) {
        qvNext.addEventListener('click', function () {
          setGalleryIndex(galleryIndex + 1);
        });
      }

      qvStage.addEventListener(
        'touchstart',
        function (event) {
          qvTouchStartX = event.changedTouches[0].clientX;
          qvTouchStartY = event.changedTouches[0].clientY;
        },
        { passive: true }
      );

      qvStage.addEventListener(
        'touchmove',
        function (event) {
          if (event.cancelable) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      qvStage.addEventListener(
        'touchend',
        function (event) {
          handleStageSwipe(
            event.changedTouches[0].clientX,
            event.changedTouches[0].clientY
          );
        },
        { passive: true }
      );

      onGlobal(window, 'popstate', function () {
        if (qvHistoryPushed && !quickview.hidden) {
          closeQuickview(true);
        }
      });

      onGlobal(window, 'keydown', function (event) {
        if (event.key === 'Escape' && !quickview.hidden) {
          closeQuickview(false);
        }

        if (event.key === 'ArrowLeft' && !quickview.hidden && isDesktop()) {
          setGalleryIndex(galleryIndex - 1);
        }

        if (event.key === 'ArrowRight' && !quickview.hidden && isDesktop()) {
          setGalleryIndex(galleryIndex + 1);
        }
      });
    }

    function initAllCarousels(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var sections = [];

      if (root.matches && root.matches('[data-mg-product-carousel-root]')) {
        sections.push(root);
      }

      Array.prototype.push.apply(
        sections,
        Array.prototype.slice.call(root.querySelectorAll('[data-mg-product-carousel-root]'))
      );

      sections.forEach(function (section) {
        if (section.id) initMiniGearProductCarousel(section.id);
      });
    }

    function cleanupCarousels(scope) {
      if (!scope || !scope.querySelectorAll) return;
      var sections = [];

      if (scope.matches && scope.matches('[data-mg-product-carousel-root]')) {
        sections.push(scope);
      }

      Array.prototype.push.apply(
        sections,
        Array.prototype.slice.call(scope.querySelectorAll('[data-mg-product-carousel-root]'))
      );

      sections.forEach(function (section) {
        var instance = carouselRegistry[section.id];
        if (instance && typeof instance.cleanup === 'function') instance.cleanup();
      });
    }

    if (!window.__MiniGearCarouselAssetLifecycle) {
      document.addEventListener('shopify:section:load', function (event) {
        initAllCarousels(event.target || document);
      });
      document.addEventListener('shopify:section:unload', function (event) {
        cleanupCarousels(event.target || document);
      });
      window.__MiniGearCarouselAssetLifecycle = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllCarousels(document);
      }, { once: true });
    } else {
      initAllCarousels(document);
    }
  })();
